// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__VdnKC","navText":"Navbar_navText__2H22h","navLogo":"Navbar_navLogo__1MD0p","imgLogo":"Navbar_imgLogo__vR1nm"};